export const environment = {
  production: false,
  apiUrl: '/api',
  contentApiUrl: 'https://dev-api.emguidance.com'
};
